module.exports = __webpack_public_path__ + "img/catalog (13).b71056c5.jpg";